<template>
  <div :key="componentKey">
    <base-header v-show="!reseller_page">
      <v-app-bar-nav-icon
        slot="nav-drawer"
        @click.stop="drawer = !drawer"
      ></v-app-bar-nav-icon>
    </base-header>

    <base-navigation-drawer
      v-show="drawer && !reseller_page"
      v-model="drawer"
    ></base-navigation-drawer>
  </div>
</template>

<script>
export default {
  name: "App",

  data: () => ({
    drawer: false,
    reseller_drawer: false,
    componentKey: 0,
    currentRouteName: null
  }),
  computed: {
    reseller_page() {
      return this.$route.name == "ResellerHome"
        || this.$route.name == "ResellerKeyAssignment"
        || this.$route.name == "ResellerCheckout"
    }
  },
  watch: {
    currentRouteName(value, oldValue) {
      if(value === oldValue) {
        this.componentKey++;
        return;
      }
    },
    "$vuetify.breakpoint.name": {
      handler: function() { 
        this.componentKey++;
        return;
      },
      immediate: true
    }
  },
  updated() {
    this.currentRouteName = this.$route.name
  }
}
</script>